
import { useState,useEffect } from "react";
import { Box,Alert,AlertIcon,AlertTitle, AlertDescription, ButtonGroup,Button,TableContainer,Table,Thead,Tbody,
  Tr,Th,Td,SkeletonCircle,SkeletonText
} from '@chakra-ui/react'
import { MdSaveAlt,MdCancel } from "react-icons/md";
import { getGovScanResultPutniceSerbr } from "../../util/apiGovScan";
const GovScanPutnicaSerBrUpdate=({govscanid,size='xs',onClose,onUpdate})=>{
    const [data,setData]=useState([]);
    const [err,setErr]=useState("");
    const [fetchisover,setFetchIsOver]=useState(false)

    useEffect(() => {
      const fetchData=async()=>{
        try {
                const res=await getGovScanResultPutniceSerbr(govscanid);
                
                if (res.status===200) {
                    
                      setData(res.res);
                    
                    
                } else {
                    throw new Error(res.message);
                }
            } catch (error) {
                setErr(error.message)
            } finally {
              setFetchIsOver(true);
            }
            
          }
      
    
      if (govscanid!==0) {
        fetchData();
      }
        
      
    }, [govscanid])
    
    const showData=()=>{
      if (fetchisover) {
        return (
          <>
          {buildScreen()}
          </>
        
        )
      } 
    }
    const buildScreen=()=>{
      if (err!=="") {
        return (
                <Alert status='error'>
                  <AlertIcon />
                  <AlertTitle>Grška kod dohvata podataka</AlertTitle>
                  <AlertDescription>{err}</AlertDescription>
              </Alert>
              )
      } else {
        if (data.length>0) {
          return (
            <TableContainer>
              <Table size={'xs'}>
                  <Thead _hover={{cursor:'pointer'}}>
                      <Tr>
                          <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rbr.</Th>
                          <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Životni broj</Th>
                          <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Trenutna putnica</Th>
                          <Th fontSize={size} textAlign={'center'} zIndex='5' pos={'sticky'} top='0' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Skenirana putnica</Th>
                      </Tr>
                  </Thead>
                  <Tbody>
                      {data.map((item,index)=>{
                            
                              return (
                                  <Tr  key={item.govedo_migracija_id}  bg={'white'} fontWeight={'normal'} color={'grunt2.700'}
                                          _hover={{bg:'gray.100',cursor:'pointer'}} h={'2rem'} 
                                          fontStyle={'normal'}>
                                              <Td fontSize={size} textAlign={'center'}>
                                                
                                                  {index+1}
                                                
                                              </Td>
                                              <Td fontSize={size} textAlign={'center'}>{item.zivbr}</Td>
                                              <Td fontSize={size} textAlign={'center'}>{item.putnica_serbr_baza}</Td>
                                              <Td fontSize={size} textAlign={'center'}>{item.putnica_serbr_scan}</Td>
                                          </Tr>
                              )    
                          
                          
                      })}
                  </Tbody>
              </Table>
            </TableContainer>
            )
        } else {
          return (
            <Alert status='warning'>
              <AlertIcon />
              <AlertTitle>Nije pronađen niti jedan očitan serijski broj putnice</AlertTitle>
          </Alert>
          )
        }
          
      }
    }
  
    const getSkeleton=()=>{
      if (fetchisover===false) {
        return (
          <Box display={'flex'} flexDir={'column'} flex={1}>
              <SkeletonCircle size='10' />
              <SkeletonText mt='4' noOfLines={15} spacing='4' skeletonHeight='4' />
          </Box>
        )
      }
    }

return (
    <Box h={'95%'} w={'100%'}>
      <Box h={'90%'} w={'100%'} overflowY={'auto'}>
        {getSkeleton()}
        {showData()}
      </Box>
      <Box h={'10%'} w={'100%'} mt={'2rem'} >
        <ButtonGroup>
          <Button rightIcon={<MdSaveAlt/>} onClick={onUpdate} size={size} colorScheme={'grunt2'} variant={'solid'}>Provedi</Button>
          <Button rightIcon={<MdCancel/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={onClose}>Odustani</Button>
        </ButtonGroup>
      </Box>
    </Box>
)

}

export default GovScanPutnicaSerBrUpdate;